/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Auto_Rate_Aria_LabelInputs */

const en_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically calculate rate and render audio`)
};

const fr_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul automatique du débit et rendu audio`)
};

const de_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Berechnung der Abtastrate und Audioausgabe`)
};

const it_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola automaticamente la frequenza e riproduci l'audio`)
};

const ru_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический расчет частоты обновления и обработка звука.`)
};

const es_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula automáticamente la velocidad y renderiza el audio.`)
};

const zh_cn2_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动计算速率并渲染音频`)
};

const ja_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レートを自動的に計算してオーディオをレンダリングします`)
};

const hi_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित रूप से दर की गणना करें और ऑडियो प्रस्तुत करें`)
};

const pt_pt2_event_ad_auto_rate_aria_label = /** @type {(inputs: Event_Ad_Auto_Rate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular automaticamente a taxa e renderizar áudio`)
};

/**
* | output |
* | --- |
* | "Automatically calculate rate and render audio" |
*
* @param {Event_Ad_Auto_Rate_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_aria_label = /** @type {((inputs?: Event_Ad_Auto_Rate_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_auto_rate_aria_label(inputs)
	if (locale === "de") return de_event_ad_auto_rate_aria_label(inputs)
	if (locale === "it") return it_event_ad_auto_rate_aria_label(inputs)
	if (locale === "ru") return ru_event_ad_auto_rate_aria_label(inputs)
	if (locale === "es") return es_event_ad_auto_rate_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_auto_rate_aria_label(inputs)
	if (locale === "ja") return ja_event_ad_auto_rate_aria_label(inputs)
	if (locale === "hi") return hi_event_ad_auto_rate_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_auto_rate_aria_label(inputs)
	return en_event_ad_auto_rate_aria_label(inputs)
});